import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import ContactForm from "../components/ContactForm";
import ManagHero from "../components/ManagHero";
import "../styles/services-pages.css";

const managementServices = [
  {
    id: "01",
    title: { en: "Strategy Consulting", ar: "استشارات استراتيجية" },
    points: {
      en: [
        "Long-term strategic plans (5–10 years)",
        "Transformation programs",
        "Operating model design",
        "Market & investment opportunity analysis",
        "Go-to-market strategies",
        "M&A strategy",
        "Turnaround strategy for distressed companies",
      ],
      ar: [
        "خطط استراتيجية طويلة المدى (5–10 سنوات)",
        "برامج التحول",
        "تصميم نموذج التشغيل",
        "تحليل السوق وفرص الاستثمار",
        "استراتيجيات الدخول إلى السوق",
        "استراتيجية الاندماج والاستحواذ",
        "استراتيجية إنقاذ وإعادة هيكلة الشركات المتعثرة",
      ],
    },
  },
  {
    id: "02",
    title: { en: "Organization & Governance", ar: "الهيكلية والحوكمة" },
    points: {
      en: [
        "Org structure design (top-down & bottom-up)",
        "Workforce planning & workload analysis",
        "Job descriptions",
        "Governance framework (policies & procedures)",
        "Internal control enhancement",
        "Governance committees & board design",
      ],
      ar: [
        "تصميم الهيكل التنظيمي (من الأعلى للأسفل ومن الأسفل للأعلى)",
        "تخطيط القوى العاملة وتحليل عبء العمل",
        "إعداد وتحديث الوصف الوظيفي",
        "إطار الحوكمة (السياسات والإجراءات)",
        "تعزيز الرقابة الداخلية",
        "تصميم اللجان ومجالس الإدارة",
      ],
    },
  },
  {
    id: "03",
    title: { en: "Operational Excellence", ar: "التميز التشغيلي" },
    points: {
      en: [
        "Business process reengineering (BPR)",
        "Lean & Six Sigma productivity improvement",
        "Process automation using RPA & AI",
        "Supply chain optimization",
        "Cost optimization & spend improvement",
        "Customer journey mapping",
      ],
      ar: [
        "إعادة هندسة العمليات (BPR)",
        "تحسين الإنتاجية بمنهجيات Lean وSix Sigma",
        "أتمتة العمليات باستخدام RPA والذكاء الاصطناعي",
        "تحسين سلاسل الإمداد",
        "تحسين التكاليف وإدارة الإنفاق",
        "رسم رحلة العميل وتحسين التجربة",
      ],
    },
  },
  {
    id: "04",
    title: { en: "Digital Transformation & Technology", ar: "التحول الرقمي والتقنية" },
    points: {
      en: [
        "Digital strategy",
        "Enterprise architecture design",
        "Digital readiness & gap assessment",
        "Automation of public & private services",
        "AI & big data analytics services",
        "ERP/CRM/HRMS selection & implementation oversight",
        "Cybersecurity & data governance",
      ],
      ar: [
        "وضع الاستراتيجية الرقمية",
        "تصميم معمارية المؤسسة",
        "قياس الجاهزية الرقمية وتحليل الفجوات",
        "أتمتة الخدمات الحكومية والخاصة",
        "خدمات الذكاء الاصطناعي وتحليلات البيانات الضخمة",
        "اختيار أنظمة ERP/CRM/HRMS والإشراف على التنفيذ",
        "الأمن السيبراني وحوكمة البيانات",
      ],
    },
  },
  {
    id: "05",
    title: { en: "Financial & Economic Advisory", ar: "الاستشارات المالية والاقتصادية" },
    points: {
      en: [
        "Advanced feasibility studies",
        "Financial statements & cash-flow analysis",
        "Valuation & company value analysis",
        "Financial restructuring",
        "Profitability & business models analysis",
        "Capital budgeting",
        "Risk management review & improvement",
      ],
      ar: [
        "دراسات جدوى متقدمة",
        "تحليل القوائم المالية والتدفقات النقدية",
        "التقييم وتحليل قيمة الشركة",
        "إعادة الهيكلة المالية",
        "تحليل الربحية ونماذج الأعمال",
        "موازنة رأس المال",
        "مراجعة وإدارة المخاطر والتحسين",
      ],
    },
  },
  {
    id: "06",
    title: { en: "HR Advisory", ar: "استشارات الموارد البشرية" },
    points: {
      en: [
        "HR strategy development",
        "HR policies & procedures",
        "Performance evaluation system",
        "Compensation, salaries & rewards structures",
        "Leadership development programs",
        "Succession planning",
      ],
      ar: [
        "تطوير استراتيجية الموارد البشرية",
        "سياسات وإجراءات الموارد البشرية",
        "نظام تقييم الأداء",
        "هياكل الرواتب والتعويضات والمكافآت",
        "برامج تطوير القيادات",
        "التخطيط للتعاقب الوظيفي",
      ],
    },
  },
  {
    id: "07",
    title: { en: "Excellence & Quality", ar: "التميز والجودة" },
    points: {
      en: [
        "EFQM & Baldrige excellence models",
        "ISO quality manuals & procedures",
        "Gap assessment (diagnostic analysis)",
        "TQM process uplift",
      ],
      ar: [
        "نماذج التميز EFQM وBaldrige",
        "أدلة الجودة وإجراءات ISO",
        "تحليل الفجوات (تشخيص وتقييم)",
        "رفع مستوى العمليات بمنهجية الجودة الشاملة TQM",
      ],
    },
  },
  {
    id: "08",
    title: { en: "Marketing & Sales Consulting", ar: "استشارات التسويق والمبيعات" },
    points: {
      en: [
        "Marketing strategy & market entry",
        "Sales team performance improvement",
        "Customer analysis & segmentation",
        "Brand identity management",
        "Pricing strategy",
      ],
      ar: [
        "استراتيجية التسويق والدخول إلى السوق",
        "تحسين أداء فريق المبيعات",
        "تحليل العملاء وتقسيم الشرائح",
        "إدارة الهوية والعلامة التجارية",
        "استراتيجية التسعير",
      ],
    },
  },
  {
    id: "09",
    title: { en: "Innovation & Business Development", ar: "الابتكار وتطوير الأعمال" },
    points: {
      en: [
        "Innovation strategies & new business models",
        "Accelerators & startup programs",
        "Internal innovation & product development",
        "International expansion & strategic partnerships",
      ],
      ar: [
        "استراتيجيات الابتكار ونماذج أعمال جديدة",
        "برامج المسرّعات والشركات الناشئة",
        "الابتكار الداخلي وتطوير المنتجات",
        "التوسع الدولي والشراكات الاستراتيجية",
      ],
    },
  },
];

function ManagementConsultingPage() {
  const [language, setLanguage] = useState("en");
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem("lang");
    if (saved === "en" || saved === "ar") setLanguage(saved);
  }, []);

  useEffect(() => {
    localStorage.setItem("lang", language);
  }, [language]);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleLanguage = () =>
    setLanguage((prev) => (prev === "en" ? "ar" : "en"));

  return (
    <div className="app" lang={language} dir="ltr">
      <Header
        language={language}
        toggleLanguage={toggleLanguage}
        isScrolled={isScrolled}
      />
      
 <ManagHero language={language} />

      <section className="service-detail-section">
        <h2 className="detail-title">
          {language === "en"
            ? "Top-Tier Management Consulting Services"
            : "خدمات الاستشارات الإدارية المتميزة"}
        </h2>

        <p className="detail-desc">
          {language === "en"
            ? "Nine key consulting domains to drive strategy, governance, operations, digital transformation, finance, HR, quality, marketing, and innovation."
            : "تسعة مجالات استشارية رئيسية لدفع الاستراتيجية والحوكمة والعمليات والتحول الرقمي والمالية والموارد البشرية والجودة والتسويق والابتكار."}
        </p>

        <div className="detail-grid">
          {managementServices.map((service) => (
            <div key={service.id} className="detail-card">
              <div className="detail-icon">{service.id}</div>
              <h3>{service.title[language]}</h3>
              <ul>
                {service.points[language].map((p, idx) => (
                  <li key={`${service.id}-${idx}`}>{p}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      <ContactForm language={language} />
    </div>
  );
}

export default ManagementConsultingPage;